import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import reducer from "reducers";
import thunk from "redux-thunk";
// import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router} from "react-router-dom";
import { registerMaintenanceInterceptor } from "actions/maintenanceActions";

// New Relic (`./newrelic`) is intentionally not imported here: CRA 4 cannot
// parse @newrelic/browser-agent@1.317 from node_modules (optional chaining).

registerMaintenanceInterceptor();

ReactDOM.render(
  <Provider store={createStore(reducer, {}, applyMiddleware(thunk))}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
